import {Box, Breadcrumbs, Typography} from "@mui/material";
import {NavLink} from "react-router-dom";

export default function MainBreadcrumbs({children}: any) {
    return (
        <Box height={50} width="100%" bgcolor="white" px={2} py={1.5} borderBottom="1px solid #EEEEEE">
            <Breadcrumbs aria-label="breadcrumb">
                <Typography fontSize={14} component={NavLink} display="block" to="/">
                    Dashboard
                </Typography>
                {children ? children : <Typography fontSize={14}>{" "}</Typography>}
            </Breadcrumbs>
        </Box>
    )
}